import { useEffect } from "react";
import { MAX_IMAGES } from "./ticketFormConfig";
import { useDeleteImageConfirm } from "./useDeleteImageConfirm";

// Attaching images to the ticket (up to 5) and confirming their deletion.
// The images themselves live in the form data, so they're sent with the rest of the ticket.
export const useImageAttachments = (images, setFormData, setSnackbar) => {
  const deleteImage = useDeleteImageConfirm(setFormData);

  useEffect(() => {
    // Cleanup object URLs when component unmounts or images change
    return () => {
      images.forEach((image) => {
        if (image instanceof File) {
          URL.revokeObjectURL(URL.createObjectURL(image));
        }
      });
    };
  }, [images]);

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    const remainingSlots = MAX_IMAGES - images.length;

    if (remainingSlots <= 0) {
      setSnackbar({ open: true, message: "ניתן להעלות מקסימום 5 תמונות", severity: "warning" });
      event.target.value = "";
      return;
    }

    // Take only the number of files that will fit within the limit
    const filesToAdd = files.slice(0, remainingSlots);

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...filesToAdd],
    }));

    if (files.length > remainingSlots) {
      setSnackbar({
        open: true,
        message: `נבחרו רק ${remainingSlots} תמונות מתוך ${files.length} בגלל המגבלה של 5 תמונות`,
        severity: "info",
      });
    }

    event.target.value = "";
  };

  return { ...deleteImage, handleImageUpload };
};
